import { Listbox, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { FileCategory } from '../../types'

type Props = {
  fileCategory: FileCategory
  setFileCategory: (category: FileCategory) => void
}

const MobileCategoryDropdown = ({ fileCategory, setFileCategory }: Props) => {
  return (
    <div className="px-3 mb-3">
      <Listbox value={fileCategory} onChange={setFileCategory}>
        <div className="relative">
          <Listbox.Button className="w-full rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm font-medium text-gray-900 hover:border-green-300 focus:border-green-400 focus:bg-white focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-10 transition-all duration-200 text-left">
            <span className="block truncate">
              {fileCategory === 'ALL' && 'All Files'}
              {fileCategory === 'LINKED' && 'Linked Files'}
              {fileCategory === 'UNLINKED' && 'Unlinked Files'}
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
              <svg
                className="h-5 w-5 text-gray-400"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04L10 14.148l2.7-1.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z"
                  clipRule="evenodd"
                />
              </svg>
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-xl py-1 text-sm ring-1 ring-black/5 focus:outline-none overflow-auto">
              <Listbox.Option
                value="ALL"
                className={({ active, selected }) =>
                  `relative cursor-pointer select-none py-3 px-4 ${
                    active ? 'bg-green-50 text-green-700' : 'text-gray-900'
                  } ${selected ? 'font-medium' : 'font-normal'}`
                }
              >
                {({ selected }) => (
                  <div className="flex items-center">
                    {selected && (
                      <span className="flex items-center text-green-500 mr-2">
                        <svg
                          className="h-4 w-4"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </span>
                    )}
                    <span className="block truncate">All Files</span>
                  </div>
                )}
              </Listbox.Option>
              <Listbox.Option
                value="LINKED"
                className={({ active, selected }) =>
                  `relative cursor-pointer select-none py-3 px-4 ${
                    active ? 'bg-green-50 text-green-700' : 'text-gray-900'
                  } ${selected ? 'font-medium' : 'font-normal'}`
                }
              >
                {({ selected }) => (
                  <div className="flex items-center">
                    {selected && (
                      <span className="flex items-center text-green-500 mr-2">
                        <svg
                          className="h-4 w-4"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </span>
                    )}
                    <span className="block truncate">Linked Files</span>
                  </div>
                )}
              </Listbox.Option>
              <Listbox.Option
                value="UNLINKED"
                className={({ active, selected }) =>
                  `relative cursor-pointer select-none py-3 px-4 ${
                    active ? 'bg-green-50 text-green-700' : 'text-gray-900'
                  } ${selected ? 'font-medium' : 'font-normal'}`
                }
              >
                {({ selected }) => (
                  <div className="flex items-center">
                    {selected && (
                      <span className="flex items-center text-green-500 mr-2">
                        <svg
                          className="h-4 w-4"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </span>
                    )}
                    <span className="block truncate">Unlinked Files</span>
                  </div>
                )}
              </Listbox.Option>
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  )
}

export default MobileCategoryDropdown
